"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6H14Zm3.5 7.1c0-1 1.33-2.1 2.33-2.1s2.34 1.1 2.34 2.1c0 .7-.21 1.89-.36 2.77l-.16.93c-.07.62-.81 1.82-1.82 1.82-1 0-1.75-1.2-1.82-1.82-.02-.2-.08-.53-.15-.93a20.2 20.2 0 0 1-.36-2.76Zm2.33 11.6a1.82 1.82 0 1 0 0-3.65 1.82 1.82 0 0 0 0 3.64Z", fill: colour }));
};
//# sourceMappingURL=Failed.js.map